module.exports = __webpack_public_path__ + "static/media/lp_ic_q.d7c4c8d8.svg";